import { CancelablePromise, OpenAPI, Response } from "@/api";
import { request as __request } from "@/api/core/request";
import { AddressAddRequest } from "@/api/models/address/AddressAddRequest";
import { ToDeleteRequest } from "@/utils/slice";
import { AddressUpdateRequest } from "@/api/models/address/AddressUpdateRequest";
import { ListRequest } from "@/api/models/ListRequest";
import { AddressListResponse } from "@/api/models/address/AddressListResponse";

export class AddressService {
  public static Add(body: AddressAddRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/user/address",
      body: body,
    });
  }

  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/user/address",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/user/address/drop",
      body: ToDeleteRequest(body),
    });
  }

  public static Update(
    body: AddressUpdateRequest
  ): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/user/address",
      body: body,
    });
  }

  public static ListAll(
    body: ListRequest
  ): CancelablePromise<AddressListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/user/address",
      body: body,
    });
  }
}
